const TrackColumn = [
    {
        title: "Sr No"
    },
    {
        title: "Track ID"
    },
    {
        title: "Src Pincode"
    },
    {
        title: "Dest Pincode"
    },
    {
        title: "Distance"
    },
    {
        title: "Duration"
    },
    {
        title: "Time"
    },
    {
        title: "Type"
    },
    {
        title: "Cost"
    }
];

export default TrackColumn;